import { fetcher } from "helpers/fetcher";

import { TUpdateFacilitiesReq, TUpdateFacilitiesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateFacilities = async (payload: TUpdateFacilitiesReq) => {
  return await fetcher<TUpdateFacilitiesRes, TUpdateFacilitiesReq["data"]>(
    ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_FACILITY,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_FACILITY.version,
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationUpdateFacilities = async (
  payload: TUpdateFacilitiesReq
) => {
  return (await updateFacilities(payload)).data;
};

mutationUpdateFacilities._key = (payload: TUpdateFacilitiesReq) => [
  ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_FACILITY.url,
  payload,
];
